import { type ReactNode } from "react";

import { cx } from "@/utils/cx";

import { Avatar, type AvatarProps } from "./avatar";

const styles = {
	lg: { root: "gap-3", subtitle: "text-md", title: "text-md font-semibold" },
	md: { root: "gap-2", subtitle: "text-sm", title: "text-sm font-semibold" },
	sm: { root: "gap-2", subtitle: "text-xs", title: "text-sm font-semibold" },
	xl: { root: "gap-4", subtitle: "text-md", title: "text-lg font-semibold" },
};

interface AvatarLabelGroupProps extends AvatarProps {
	size: "lg" | "md" | "sm" | "xl";
	subtitle: ReactNode | string;
	title: ReactNode | string;
}

export const AvatarLabelGroup = ({
	className,
	subtitle,
	title,
	...props
}: AvatarLabelGroupProps) => {
	return (
		<figure
			className={cx(
				"group flex min-w-0 flex-1 items-center",
				styles[props.size].root,
				className,
			)}
		>
			<Avatar {...props} />
			<figcaption className="min-w-0 flex-1">
				<p className={cx("text-primary", styles[props.size].title)}>{title}</p>
				<p
					className={cx("truncate text-tertiary", styles[props.size].subtitle)}
				>
					{subtitle}
				</p>
			</figcaption>
		</figure>
	);
};
